if (!customElements.get("m-gmaps")) {
  class MGmaps extends HTMLElement {
    constructor() {
      super();
      this.mapElm = this.querySelector("#gmaps-inner");
      this.mapAddress = this.mapElm.dataset.mapTitle;
      this.mapZoom = this.mapElm.dataset.mapZoom;
      this.mapX = this.mapElm.dataset.mapX;
      this.mapY = this.mapElm.dataset.mapY;
      if (!HimiSettings.gm_api) {
        return;
      }
    }

    connectedCallback() {
      this.prepMapApi();
    }

    prepMapApi() {
      this.loadScript().then(this.initMap.bind(this));
    }

    loadScript() {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = "https://maps.googleapis.com/maps/api/js?key=" + HimiSettings.gm_api;
      });
    }

    initMap() {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: this.mapAddress }, (results, status) => {
        if (status !== google.maps.GeocoderStatus.OK) {
          if (Shopify.designMode) {
          }
        } else {
          this.mapX = results[0].geometry.location.lat();
          this.mapY = results[0].geometry.location.lng();
          const mapOptions = {
            zoom: parseInt(this.mapZoom),
            center: new google.maps.LatLng(this.mapX, this.mapY),
            draggable: true,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true,
            styles: [
              {
                  "featureType": "administrative",
                  "elementType": "labels.text.fill",
                  "stylers": [
                      {
                          "color": "#686868"
                      }
                  ]
              },
              {
                  "featureType": "landscape",
                  "elementType": "all",
                  "stylers": [
                      {
                          "color": "#f2f2f2"
                      }
                  ]
              },
              {
                  "featureType": "poi",
                  "elementType": "all",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              },
              {
                  "featureType": "road",
                  "elementType": "all",
                  "stylers": [
                      {
                          "saturation": -100
                      },
                      {
                          "lightness": 45
                      }
                  ]
              },
              {
                  "featureType": "road.highway",
                  "elementType": "all",
                  "stylers": [
                      {
                          "visibility": "simplified"
                      }
                  ]
              },
              {
                  "featureType": "road.highway",
                  "elementType": "geometry.fill",
                  "stylers": [
                      {
                          "lightness": "-22"
                      }
                  ]
              },
              {
                  "featureType": "road.highway",
                  "elementType": "geometry.stroke",
                  "stylers": [
                      {
                          "saturation": "11"
                      },
                      {
                          "lightness": "-51"
                      }
                  ]
              },
              {
                  "featureType": "road.highway",
                  "elementType": "labels.text",
                  "stylers": [
                      {
                          "saturation": "3"
                      },
                      {
                          "lightness": "-56"
                      },
                      {
                          "weight": "2.20"
                      }
                  ]
              },
              {
                  "featureType": "road.highway",
                  "elementType": "labels.text.fill",
                  "stylers": [
                      {
                          "lightness": "-52"
                      }
                  ]
              },
              {
                  "featureType": "road.highway",
                  "elementType": "labels.text.stroke",
                  "stylers": [
                      {
                          "weight": "6.13"
                      }
                  ]
              },
              {
                  "featureType": "road.highway",
                  "elementType": "labels.icon",
                  "stylers": [
                      {
                          "lightness": "-10"
                      },
                      {
                          "gamma": "0.94"
                      },
                      {
                          "weight": "1.24"
                      },
                      {
                          "saturation": "-100"
                      },
                      {
                          "visibility": "off"
                      }
                  ]
              },
              {
                  "featureType": "road.arterial",
                  "elementType": "geometry",
                  "stylers": [
                      {
                          "lightness": "-16"
                      }
                  ]
              },
              {
                  "featureType": "road.arterial",
                  "elementType": "labels.text.fill",
                  "stylers": [
                      {
                          "saturation": "-41"
                      },
                      {
                          "lightness": "-41"
                      }
                  ]
              },
              {
                  "featureType": "road.arterial",
                  "elementType": "labels.text.stroke",
                  "stylers": [
                      {
                          "weight": "5.46"
                      }
                  ]
              },
              {
                  "featureType": "road.arterial",
                  "elementType": "labels.icon",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              },
              {
                  "featureType": "road.local",
                  "elementType": "geometry.fill",
                  "stylers": [
                      {
                          "weight": "0.72"
                      },
                      {
                          "lightness": "-16"
                      }
                  ]
              },
              {
                  "featureType": "road.local",
                  "elementType": "labels.text.fill",
                  "stylers": [
                      {
                          "lightness": "-37"
                      }
                  ]
              },
              {
                  "featureType": "transit",
                  "elementType": "all",
                  "stylers": [
                      {
                          "visibility": "off"
                      }
                  ]
              },
              {
                  "featureType": "water",
                  "elementType": "all",
                  "stylers": [
                      {
                          "color": "#b7e4f4"
                      },
                      {
                          "visibility": "on"
                      }
                  ]
              }
          ]
          };
          const map = new google.maps.Map(this.mapElm, mapOptions);
          new google.maps.Marker({
            map: map,
            position: new google.maps.LatLng(this.mapX, this.mapY),
            title: this.mapAddress,
          });

          google.maps.event.addDomListener(window, "resize", function () {
            google.maps.event.trigger(map, "resize");
          });
        }
      });
    }
  }

  customElements.define("m-gmaps", MGmaps);
}
